// 전자문서 업무 종류
export enum EdocTranType {
  LOAN = '1', // 대출
  BANCA = '2', // 방카
  FUND = '3', // 펀드
  CERTIFICATES = '4', //증명서
}

// 전자문서 요청 타입
export enum EdocIbReportMode {
  NONE = '',
  VIEW = 'view',
  // MERGE = 'mergeReg', // 미사용
  // EXPORT = 'export', // 미사용
  // ??? = 'export'
}
